import { useState } from 'react';
import { Sparkles, Check, X, Loader2 } from 'lucide-react';
import api from '../../services/api';
import useCustomStore from '../../store/customStore';

/**
 * Nom proposé par l'IA pour un sujet perso (migration 263), affiché sous la carte.
 * « Utiliser » renomme le sujet (et la thématique si elle n'a que ce sujet et que la
 * case est cochée) ; × l'écarte. Dans les deux cas la proposition disparaît côté serveur.
 */
export default function SuggestedLabel({ customSsId, suggestion, singleSujet = false, onDone }) {
    const [busy, setBusy] = useState(null); // 'accept' | 'dismiss'
    const [withThematique, setWithThematique] = useState(true);
    const [error, setError] = useState(null);
    const fetchThematiques = useCustomStore(s => s.fetchThematiques);

    const act = async (action) => {
        setBusy(action);
        setError(null);
        try {
            const { data } = await api.put('/custom/categories.php', {
                suggested_label_action: action,
                custom_ss_id: customSsId,
                rename_thematique: action === 'accept' && singleSujet && withThematique,
            });
            if (data?.data?.thematique_label) await fetchThematiques();
            if (onDone) onDone();
        } catch (e) {
            setError(e.response?.data?.message || 'Action impossible pour le moment.');
            setBusy(null);
        }
    };

    return (
        <div className="mt-suggest" onClick={e => e.stopPropagation()}>
            <div className="mt-suggest__line">
                <Sparkles size={13} className="mt-suggest__icon" aria-hidden />
                <span className="mt-suggest__text">
                    Nom proposé : <strong>{suggestion}</strong>
                </span>
            </div>
            {singleSujet && (
                <label className="mt-suggest__check">
                    <input type="checkbox" checked={withThematique} onChange={e => setWithThematique(e.target.checked)} />
                    Renommer aussi la thématique
                </label>
            )}
            <div className="mt-suggest__actions">
                <button type="button" className="mt-suggest__use" disabled={!!busy} onClick={() => act('accept')}>
                    {busy === 'accept' ? <Loader2 size={12} className="spin" /> : <Check size={12} />}
                    Utiliser
                </button>
                <button type="button" className="mt-suggest__dismiss" disabled={!!busy} onClick={() => act('dismiss')}
                    title="Garder le nom actuel" aria-label="Ignorer la proposition">
                    {busy === 'dismiss' ? <Loader2 size={12} className="spin" /> : <X size={12} />}
                    Garder le nom actuel
                </button>
            </div>
            {error && <div className="mt-suggest__error">{error}</div>}
        </div>
    );
}
